module.exports = __webpack_public_path__ + "c4a7826cc780c5e74df8cafe6f66aaae.svg";